import { useEffect, useState } from "react"
import { useGetLoggedInUserDetails } from "./useGetLoggedInUserDetails"

export const useAccessTypes = () => {
    const { loggedInUser } = useGetLoggedInUserDetails()

    /**
     [
    {
        "roleId": "f49f7717-5bae-4ba4-b069-1fa1502ee88e",
        "role": "A2 - Client Account Admin",
        "groupName": "G3"
    },
    {
        "roleId": "82511c17-b73c-4b9f-b0b2-2794c8425ca9",
        "role": "A1 - Super Admin - Client Portal",
        "groupName": "G3"
    },
    {
        "roleId": "94564334-a8fb-4431-a758-9ee95ddb9908",
        "role": "A3 - Client Sub-Account Admin",
        "groupName": "G3"
    },
    {
        "roleId": "a88ae2de-3145-4ec5-9bec-28156ab8ec7d",
        "role": "Admin",
        "groupName": "G2"
    },
    {
        "roleId": "4ef0de15-50ce-4d09-8931-2cbf13625282",
        "role": "Enterprise Admin",
        "groupName": "G1"
    },
    {
        "roleId": "c4876d2c-13a8-4dfd-b58b-34bdacacf5d6",
        "role": "Super Admin",
        "groupName": "G2"
    },
    {
        "roleId": "e1ae1bfe-ae3c-482b-932b-693c95cd113c",
        "role": "Coach",
        "groupName": "G2"
    },
    {
        "roleId": "4b74544d-6023-4375-b8bb-d6b39f787dce",
        "role": "Coach Admin",
        "groupName": "G2"
    }
]
     */
    /**enterprise admin access */
    const [isEnterpriseAdmin, setIsEnterpriseAdmin] = useState(false)

    /**candidate portal access */
    const [isCandidatePortalAdmin, setIsCandidatePortalAdmin] = useState(false)
    const [hasAdminAccess, setHasAdminAccess] = useState(false)
    const [hasSuperAdminAccess, setHasSuperAdminAccess] = useState(false)
    const [hasCoachAccess, setHasCoachAccess] = useState(false)
    const [hasCoachAdminAccess, setHasCoachAdminAccess] = useState(false)

    /**client portal access */
    const [isClientPortalAdmin, setIsClientPortalAdmin] = useState(false)
    const [hasA1Access, setHasA1Access] = useState(false)
    const [hasA2Access, setHasA2Access] = useState(false)
    const [hasA3Access, setHasA3Access] = useState(false)
    const [hasA4Access, setHasA4Access] = useState(false)

    // const candidatePortalAdminRegEx = /Super Admin|Admin|Coach|Coach Admin/
    const enterpriseAdminRegEx = /4ef0de15-50ce-4d09-8931-2cbf13625282/

    const candidatePortalAdminRegEx = /c4876d2c-13a8-4dfd-b58b-34bdacacf5d6|e1ae1bfe-ae3c-482b-932b-693c95cd113c|4b74544d-6023-4375-b8bb-d6b39f787dce|a88ae2de-3145-4ec5-9bec-28156ab8ec7d/

    // const clientPortalAdminRegEx = /A1|A2|A3/
    const clientPortalAdminRegEx = /f49f7717-5bae-4ba4-b069-1fa1502ee88e|82511c17-b73c-4b9f-b0b2-2794c8425ca9|94564334-a8fb-4431-a758-9ee95ddb9908|9f5b89c1-e57b-4ea1-a2cd-8d481a626ee8/

    useEffect(() => {
        if (!!loggedInUser?.id) {
            const roleId = loggedInUser?.role?.role?.roleId || ""
            const clientPortalAdminRoleId = loggedInUser?.clientPortalAdminRoleId || ""

            if (roleId.search(enterpriseAdminRegEx) !== -1) {
                setIsEnterpriseAdmin(true)

                setIsCandidatePortalAdmin(false)
                setIsClientPortalAdmin(false)

                setHasAdminAccess(false)
                setHasSuperAdminAccess(false)
                setHasCoachAccess(false)
                setHasCoachAdminAccess(false)

                setHasA1Access(false)
                setHasA2Access(false)
                setHasA3Access(false)
                setHasA4Access(false)
            } else {
                /**candidate portal access */
                // console.log("candidatePortalAdminRegEx", roleId.search(candidatePortalAdminRegEx))

                if (roleId.search(candidatePortalAdminRegEx) !== -1) {
                    setIsCandidatePortalAdmin(true)

                    const superAdminRegex = /c4876d2c-13a8-4dfd-b58b-34bdacacf5d6/
                    const adminRegex = /a88ae2de-3145-4ec5-9bec-28156ab8ec7d/
                    const coachRegex = /e1ae1bfe-ae3c-482b-932b-693c95cd113c/
                    const coachAdminRegex = /4b74544d-6023-4375-b8bb-d6b39f787dce/

                    if (roleId.search(superAdminRegex) !== -1) {
                        setHasSuperAdminAccess(true)
                        setHasAdminAccess(false)
                        setHasCoachAccess(false)
                        setHasCoachAdminAccess(false)

                    } else if (roleId.search(adminRegex) !== -1) {
                        setHasSuperAdminAccess(false)
                        setHasAdminAccess(true)
                        setHasCoachAccess(false)
                        setHasCoachAdminAccess(false)

                    } else if (roleId.search(coachRegex) !== -1) {
                        setHasSuperAdminAccess(false)
                        setHasAdminAccess(false)
                        setHasCoachAccess(true)
                        setHasCoachAdminAccess(false)

                    } else if (roleId.search(coachAdminRegex) !== -1) {
                        setHasSuperAdminAccess(false)
                        setHasAdminAccess(false)
                        setHasCoachAccess(false)
                        setHasCoachAdminAccess(true)
                    }
                }

                /**client portal access */
                if (clientPortalAdminRoleId.search(clientPortalAdminRegEx) !== -1) {
                    const a1Regex = /82511c17-b73c-4b9f-b0b2-2794c8425ca9/ //A1
                    const a2Regex = /f49f7717-5bae-4ba4-b069-1fa1502ee88e/ //A2
                    const a3Regex = /94564334-a8fb-4431-a758-9ee95ddb9908/ //A3

                    const a4Regex = /9f5b89c1-e57b-4ea1-a2cd-8d481a626ee8/ //A4


                    setIsClientPortalAdmin(true)
                    if (clientPortalAdminRoleId.search(a1Regex) !== -1) {
                        setHasA1Access(true)
                        setHasA2Access(false)
                        setHasA3Access(false)
                        setHasA4Access(false)
                    } else if (clientPortalAdminRoleId.search(a2Regex) !== -1) {
                        setHasA1Access(false)
                        setHasA2Access(true)
                        setHasA3Access(false)
                        setHasA4Access(false)
                    } else if (clientPortalAdminRoleId.search(a3Regex) !== -1) {
                        setHasA1Access(false)
                        setHasA2Access(false)
                        setHasA3Access(true)
                        setHasA4Access(false)
                    } else if (clientPortalAdminRoleId.search(a4Regex) !== -1) {
                        setHasA1Access(false)
                        setHasA2Access(false)
                        setHasA3Access(false)
                        setHasA4Access(true)
                    }
                }
            }
        }
    }, [loggedInUser])


    return {
        isEnterpriseAdmin,
        candidatePortalAdminType: {
            isCandidatePortalAdmin,
            hasSuperAdminAccess,
            hasAdminAccess,
            hasCoachAccess,
            hasCoachAdminAccess,
        },
        clientPortalAdminType: {
            isClientPortalAdmin,
            hasA1Access,
            hasA2Access,
            hasA3Access,
            hasA4Access
        }
    }
}